import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const ValidateConvertPageToMarkdownModeQuery: GraphQLTaggedNode = graphql`
	query ValidateConvertPageToMarkdownModeQuery($cloudId: ID!, $contentId: ID!) {
		confluence_validateConvertPageToMarkdownMode(cloudId: $cloudId, contentId: $contentId) {
			isLossless
		}
	}
`;
